export const urlPrefixB2B_B2C = {
  b2b: {
    fr: 'professionnels',
    nl: 'professioneel',
    en: 'business',
  },
  b2c: {
    fr: 'particuliers',
    nl: 'particulieren',
    en: 'individuals',
  },
};

export enum ClientType {
  B2B = 'B2B',
  B2C = 'B2C',
}

export class TypeDetectorService {
  static detectType(): ClientType {
    const segments: string[] = window.location.pathname.split('/').filter((segment) => segment !== '');
    // Use the urlPrefixB2B_B2C object to get all possible B2B prefixes
    const b2bPrefixes = Object.values(urlPrefixB2B_B2C.b2b);
    return segments.find((segment) => b2bPrefixes.includes(segment)) ? ClientType.B2B : ClientType.B2C;
  }
}
